var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/opt/build/repo/node_modules/@babel/runtime/helpers/objectSpread2");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var utils = require('./utils');

var Row = function Row() {
  "use strict";

  _classCallCheck(this, Row);
};

var Collection =
/*#__PURE__*/
function () {
  "use strict";

  function Collection(collectionId, collectionViewId, rawData, client) {
    var _this = this;

    _classCallCheck(this, Collection);

    this.collectionId = collectionId;
    this.collectionViewId = collectionViewId;
    this.rawData = rawData;
    this.client = client;
    this._schema = rawData.recordMap.collection[collectionId].value.schema;
    this.total = rawData.result.total;
    this.value = rawData.recordMap.collection[collectionId].value;
    this.props = Object.entries(this._schema).map(function (item) {
      var _item = _slicedToArray(item, 2),
          key = _item[0],
          v = _item[1];

      return v.name;
    });
    this.props.push('_raw');
    this.propsKeyMap = {};
    Object.entries(this._schema).map(function (item) {
      var _item2 = _slicedToArray(item, 2),
          key = _item2[0],
          v = _item2[1];

      _this.propsKeyMap[v.name] = _objectSpread({
        key: key
      }, v);
    }); // cache

    this.client.blockStore = _objectSpread({}, this.client.blockStore, {}, rawData.recordMap.block);
    this.completed = false;
    return _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.total > 980)) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.fetchMore();

            case 3:
              _this.completed = true;
              return _context.abrupt("return", _this);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  }

  _createClass(Collection, [{
    key: "fetchMore",
    value: function () {
      var _fetchMore = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var data, blockIds, blocksDataList;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.client.queryCollection(this.collectionId, this.collectionViewId, this.total);

              case 2:
                data = _context2.sent;
                blockIds = data.result.blockIds.slice(980, this.total);
                _context2.next = 6;
                return this.client.getRecordValues(blockIds, []);

              case 6:
                blocksDataList = _context2.sent;
                blocksDataList.forEach(function (item) {
                  _this2.client.blockStore[item.value.id] = item;
                }); // update blockIds

                this.rawData.result = data.result;

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function fetchMore() {
        return _fetchMore.apply(this, arguments);
      }

      return fetchMore;
    }()
  }, {
    key: "addRow",
    value: function addRow(data) {
      var _this3 = this;

      var newId = this.client.genId();
      var args = {};
      var updateData;

      if (data) {
        Object.entries(data).map(function (item) {
          var _item3 = _slicedToArray(item, 2),
              prop = _item3[0],
              value = _item3[1];

          var notionData = _this3.js2notion(prop, value, _this3.propsKeyMap);

          var _this3$propsKeyMap$pr = _this3.propsKeyMap[prop],
              key = _this3$propsKeyMap$pr.key,
              type = _this3$propsKeyMap$pr.type;
          args[key] = notionData;
        });
        updateData = {
          "id": newId,
          "table": "block",
          "path": ["properties"],
          "command": "set",
          "args": args
        };
      }

      var postData = {
        "operations": [{
          args: {
            type: "page",
            id: newId,
            version: 1
          },
          command: "set",
          id: newId,
          path: [],
          table: "block"
        }, // create new row block
        {
          args: {
            parent_id: this.collectionId,
            parent_table: "collection",
            alive: true
          },
          command: "update",
          id: newId,
          path: [],
          table: "block"
        }, // set parent node
        {
          args: {
            // created_by: "c8e68ca2-a84d-4792-a6d6-1e7716982001",
            created_time: new Date().getTime(),
            // last_edited_by: "c8e68ca2-a84d-4792-a6d6-1e7716982001",
            last_edited_time: new Date().getTime()
          },
          command: "update",
          id: newId,
          path: [],
          table: "block"
        } // [fixme] set create/edit time
        ]
      };

      if (updateData) {
        postData.operations.push(updateData);
      }

      this.client.reqeust.post('/api/v3/submitTransaction', postData);
      this.client.blockStore[newId] = {
        value: {
          id: newId,
          parent_id: this.collectionId,
          parent_table: "collection",
          alive: true,
          created_time: new Date().getTime(),
          last_edited_time: new Date().getTime(),
          properties: args
        }
      };
      return this.makeRow(newId, this._schema);
    }
  }, {
    key: "checkOrCreateSelectOptions",
    value: function checkOrCreateSelectOptions(prop, value, type) {
      var _this4 = this;

      // init options fix
      if (!this.schema[prop].options) {
        this.schema[prop].options = [];
      }

      if (type === "select") {
        if (!this.schema[prop].options.find(function (o) {
          return o.value === value;
        })) {
          // if select value is not exists,create it & update schema
          this.schema[prop].options.push({
            id: this.client.genId(),
            value: value
          });
          this.updateSchema();
        }
      } else if (type === "multi_select") {
        var needUpdateSchema = false;
        value.map(function (v) {
          if (!_this4.schema[prop].options.find(function (o) {
            return o.value === v;
          })) {
            // if select value is not exists,create it & update schema
            needUpdateSchema = true;

            _this4.schema[prop].options.push({
              id: _this4.client.genId(),
              value: v
            });
          }
        });

        if (needUpdateSchema) {
          this.updateSchema();
        }
      }
    }
  }, {
    key: "js2notion",
    value: function js2notion(prop, value, propsKeyMap) {
      var newV; // fuck babel

      switch (propsKeyMap[prop].type) {
        case 'title':
        case 'text':
        case 'url':
        case 'email':
        case 'phone_number':
        case 'number':
          newV = [[value + ""]]; // 强制转化成字符串，否则后续修改表格数据可能会造成客户端崩溃。

          break;

        case 'checkbox':
          newV = value ? [['Yes']] : [['No']];
          break;

        case 'file':
          if (value.length === 1 && value[0]) {
            newV = [[value[0], [["a", value[0]]]]];
          } else if (value.length === 0) {
            newV = [];
          } else {
            newV = value.reduce(function (a, b, index) {
              if (index === 1) {
                return [[a, [["a", a]]]].concat([[","], [b, [["a", b]]]]);
              } else {
                return a.concat([[","], [b, [["a", b]]]]);
              }
            });
          }

          break;

        case 'select':
          this.checkOrCreateSelectOptions(prop, value, 'select');
          newV = [[value + ""]];
          break;

        case 'multi_select':
          this.checkOrCreateSelectOptions(prop, value, 'multi_select');

          if (value instanceof Array) {
            value.map(function (v) {});
            newV = [[value.join(',')]];
          }

          break;

        case 'person':
          if (value instanceof Array) {
            if (value.length === 1) {
              newV = [["‣", [["u", value[0]]]]];
            } else if (value.length === 0) {
              newV = [];
            } else {
              newV = value.reduce(function (a, b, index) {
                if (index === 1) {
                  return [["‣", [["u", a]]]].concat([[","], ["‣", [["u", b]]]]);
                } else {
                  return a.concat([[","], ["‣", [["u", b]]]]);
                }
              });
            }
          } else {
            throw Error();
          }

          break;

        case 'date':
          var type = 'date';

          if (value.includeTime) {
            type += 'time';
          }

          if (value.endDate) {
            type += 'range';
          }

          var timeZone = value.timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
          var startDate = value.startDate;
          var endDate = value.endDate;
          newV = [["‣", [["d", {
            time_zone: timeZone,
            type: type,
            start_date: startDate ? utils.formatDate(utils.unFixTimeZone(startDate, timeZone)) : undefined,
            start_time: startDate && value.includeTime ? utils.formatTime(utils.unFixTimeZone(startDate, timeZone)) : undefined,
            end_date: endDate ? utils.formatDate(utils.unFixTimeZone(endDate, timeZone)) : undefined,
            end_time: endDate && value.includeTime ? utils.formatTime(utils.unFixTimeZone(endDate, timeZone)) : undefined
          }]]]];
          break;

        case 'relation':
          // check value type , should be Row
          if (value instanceof Array) {
            if (value.length === 1 && value[0] instanceof Row) {
              newV = [["‣", [["p", value[0].id]]]];
            } else if (value.length === 0) {
              newV = [];
            } else {
              newV = value.filter(function (v) {
                return v instanceof Row;
              }).reduce(function (a, b, index) {
                if (index === 1) {
                  return [["‣", [["p", a.id]]]].concat([[","], ["‣", [["p", b.id]]]]);
                } else {
                  return a.concat([[","], ["‣", [["p", b.id]]]]);
                }
              });
            } // fixme check (schema[key].collection_id === value.parent_id && value.parent_table === "collection")
            // throw Error()

          } else {
            throw Error();
          }

          break;

        default:
          newV = [[value + ""]];
      }

      return newV;
    }
  }, {
    key: "notion2js",
    value: function notion2js(rawValue, type, collection_id) {
      var _this5 = this;

      var res;

      if (rawValue) {
        switch (type) {
          case 'title':
          case 'url':
          case 'email':
          case 'phone_number':
          case 'select':
          case 'number':
            res = rawValue[0][0];
            break;

          case 'text':
            res = rawValue[0][0];

            if (res === "‣") {
              res = rawValue[0][1][0][1];
            }

            break;

          case 'checkbox':
            res = Boolean(rawValue[0][0] === 'Yes');
            break;

          case 'date':
            {
              var date = rawValue[0][1][0][1];
              res = {
                startDate: date.start_date ? utils.fixTimeZone("".concat(date.start_date, " ").concat(date.start_time || '00:00'), date.time_zone) : undefined,
                endDate: date.end_date ? utils.fixTimeZone("".concat(date.end_date, " ").concat(date.end_time || '00:00'), date.time_zone) : undefined,
                includeTime: date.type.indexOf("time") !== -1,
                timeZone: date.time_zone
              };
              break;
            }

          case 'multi_select':
            res = rawValue[0][0].split(',');
            break;

          case 'file':
            res = rawValue.filter(function (item) {
              var content = item[1];
              return Boolean(content);
            }).map(function (item) {
              return item[1][0][1];
            });
            break;

          case 'person':
            res = rawValue.filter(function (item) {
              return item.length > 1;
            }).map(function (item) {
              return item[1][0][1];
            });
            break;

          case 'relation':
            res = rawValue.filter(function (item) {
              return item.length > 1;
            }).map(function (item) {
              var _schema = _this5.client.collectionSchemaStore[collection_id];
              var _blockId = item[1][0][1];

              if (_schema) {
                return _this5.makeRow(_blockId, _schema);
              } else {
                console.log("failed to get relation of ".concat(_blockId));
                return undefined;
              }
            });
            break;

          case 'rollup':
            res = rawValue.filter(function (item) {
              return item.length > 1;
            }).map(function (item) {
              return item[1][0];
            });
            break;

          default:
            res = rawValue;
        }
      }

      return res;
    }
  }, {
    key: "makeRow",
    value: function makeRow(rowBlockId, schema) {
      var _this6 = this;

      if (!schema) return undefined;
      var rowData = rowBlockId in this.client.blockStore ? this.client.blockStore[rowBlockId].value : undefined;
      var props = Object.entries(schema).map(function (item) {
        var _item4 = _slicedToArray(item, 2),
            key = _item4[0],
            v = _item4[1];

        return v.name;
      });
      props.push('_raw');
      var propsKeyMap = {};
      Object.entries(schema).map(function (item) {
        var _item5 = _slicedToArray(item, 2),
            key = _item5[0],
            v = _item5[1];

        propsKeyMap[v.name] = _objectSpread({
          key: key
        }, v);
      });

      if (rowData) {
        var handlers = {
          getPrototypeOf: function getPrototypeOf(target) {
            return new Row();
          },
          get: function get(target, property) {
            if (target.hasOwnProperty(property)) {
              return target[property];
            } else if (props.indexOf(property) > -1) {
              if (property === '_raw') {
                return target;
              } else {
                var _propsKeyMap$property = propsKeyMap[property],
                    key = _propsKeyMap$property.key,
                    type = _propsKeyMap$property.type,
                    collection_id = _propsKeyMap$property.collection_id;
                var rawValue = target.properties ? target.properties[key] : false;
                return _this6.notion2js(rawValue, type, collection_id);
              }
            } else if (property === "delete") {
              var del = function del() {
                var postData = {
                  "operations": [{
                    "id": target.id,
                    "table": "block",
                    "path": [],
                    "command": "update",
                    "args": {
                      parent_id: _this6.collectionId,
                      parent_table: "collection",
                      alive: false
                    }
                  }, {
                    "id": target.id,
                    "table": "block",
                    "path": ["last_edited_time"],
                    "command": "set",
                    "args": new Date().getTime()
                  }]
                };

                _this6.client.reqeust.post('/api/v3/submitTransaction', postData);
              };

              return del;
            } else {
              return undefined;
            }
          },
          set: function set(target, prop, value, _self) {
            if (props.indexOf(prop) > -1) {
              var newV = _this6.js2notion(prop, value, propsKeyMap);

              var _propsKeyMap$prop = propsKeyMap[prop],
                  key = _propsKeyMap$prop.key,
                  type = _propsKeyMap$prop.type;
              var postData = {
                "operations": [{
                  "id": target.id,
                  "table": "block",
                  "path": ["properties", key],
                  "command": "set",
                  "args": newV
                }, {
                  "id": target.id,
                  "table": "block",
                  "path": [],
                  "command": "update",
                  "args": {
                    "last_edited_time": new Date().getTime()
                  }
                }]
              };

              _this6.client.reqeust.post('/api/v3/submitTransaction', postData);

              _self = Reflect.set(target, prop, value);
              return _self;
            } else if (["formatPageIcon", "formatPageCover", "formatPageCoverPosition"].includes(prop)) {
              // 设置头图和 icon
              var path;

              switch (prop) {
                case "formatPageIcon":
                  path = ["format", "page_icon"];
                  break;

                case "formatPageCover":
                  path = ["format", "page_cover"];
                  break;

                case "formatPageCoverPosition":
                  path = ["format", "page_cover_position"];
                  break;
              }

              var _postData = {
                "operations": [{
                  "id": target.id,
                  "table": "block",
                  "path": path,
                  "command": "set",
                  "args": value
                }, {
                  "id": target.id,
                  "table": "block",
                  "path": [],
                  "command": "update",
                  "args": {
                    "last_edited_time": new Date().getTime()
                  }
                }]
              };

              _this6.client.reqeust.post('/api/v3/submitTransaction', _postData);

              return;
            }
          }
        };
        var proxy = new Proxy(rowData, handlers); // proxy.toString = Function.prototype.toString.bind(rowData)

        return proxy;
      }
    }
  }, {
    key: "updateSchema",
    value: function updateSchema() {
      var postData = {
        "operations": [{
          "id": this.collectionId,
          "table": "collection",
          "path": [],
          "command": "update",
          "args": {
            schema: this._schema
          }
        }]
      };
      this.client.reqeust.post('/api/v3/submitTransaction', postData);
    }
  }, {
    key: "rows",
    get: function get() {
      var _this7 = this;

      var blockIds = this.rawData.result.blockIds;
      return blockIds.map(function (blockId) {
        return _this7.makeRow(blockId, _this7._schema);
      });
    }
  }, {
    key: "schema",
    get: function get() {
      var _this8 = this;

      //
      var handlers = {
        get: function get(target, prop) {
          var key = _this8.propsKeyMap[prop].key;
          return _this8._schema[key];
        } // set: (target, prop, value) => {
        //     let key = this.propsKeyMap[prop].key
        //     this._schema[key] = value
        //     let postData = {
        //         "operations": [
        //             { "id": this.collectionId, "table": "collection", "path": [], "command": "update", "args": { schema: this._schema } },
        //         ]
        //     }
        //     this.client.reqeust.post('/api/v3/submitTransaction', postData)
        //     return
        // }

      };
      var proxy = new Proxy(this._schema, handlers);
      return proxy;
    }
  }]);

  return Collection;
}();

module.exports = Collection;